let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8;
import styled, { css } from 'styled-components';
import { fontSize, styledIf } from '@ovpn-ui/styles';
import { opacityBlur } from '../Navigation.utils';
export const PanelContent = styled.div(_t || (_t = _`
    display: flex;
    flex-direction: column;
    height: 100%;

    color: ${0};
`), t => t.theme.text);
/** Default LinksList wrapper styles, also exported from the package and usable in `customWrapper` */
export const linksListStyleMixin = css(_t2 || (_t2 = _`
    height: 100%;
    margin: 0;
    padding: 0px 12px 88px 12px;
    overflow-x: hidden;
    overflow-y: 'scroll';

    list-style: none;

    transition: padding 225ms cubic-bezier(0.4, 0, 0.6, 1) 30ms;

    will-change: padding;

    ${0}
`), ({
  $hasTenants,
  $mobile
}) => !$hasTenants && $mobile && `
        margin-top: 64px;
    `);
export const LinksList = styled.ul(_t3 || (_t3 = _`
    ${0}
`), linksListStyleMixin);
export const GroupSeparator = styled.div(_t4 || (_t4 = _`
    margin-bottom: 8px;

    border-bottom: 1px solid ${0};
`), t => t.theme.border);
export const Copyright = styled.div(_t5 || (_t5 = _`
    margin-top: auto;
    padding: 32px 33px 24px 33px;
    overflow: hidden;

    color: ${0};
    font-size: ${0};
    line-height: ${0};
    white-space: nowrap;
    text-align: center;

    ${0}
`), t => t.theme.text, fontSize.xxSmall, fontSize.medium, opacityBlur());
export const LogoContainer = styled.div(_t6 || (_t6 = _`
    display: flex;
    align-items: center;
    padding: 32px 0 32px 20px;

    white-space: nowrap;

    border-bottom: ${0};

    ${0}

    ${0}
`), t => t.mobile ? `1px solid ${t.theme.border}` : '', styledIf('mobile')(_t7 || (_t7 = _`    
        display: flex;
        alignItems: center;
        justifyContent: space-between;

        width: 100%;
        height: 56px;
        min-height: 56px;

        padding: 16px;
    `)), styledIf('hasTenants')(_t8 || (_t8 = _`    
        padding-bottom: 20px;
    `)));